import { render, staticRenderFns } from "./PAYGCheckoutComplete.vue?vue&type=template&id=a838453e&"
import script from "./PAYGCheckoutComplete.vue?vue&type=script&lang=js&"
export * from "./PAYGCheckoutComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports